import { useState } from 'react';
import { X } from 'lucide-react';
import { Checkbox } from './ui/checkbox';
import { Input } from './ui/input';
import { Button } from './ui/button';

// Multi-select checkbox group with optional custom values.
export function CheckboxGroup({ options, value = [], onChange, allowCustom = true, testid }) {
  const [custom, setCustom] = useState('');
  const selected = Array.isArray(value) ? value : [];

  const toggle = (opt) => {
    if (selected.includes(opt)) onChange(selected.filter((v) => v !== opt));
    else onChange([...selected, opt]);
  };

  const addCustom = () => {
    const v = custom.trim();
    if (v && !selected.includes(v)) onChange([...selected, v]);
    setCustom('');
  };

  const customValues = selected.filter((v) => !options.includes(v));

  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="flex flex-wrap gap-x-4 gap-y-2">
        {options.map((opt) => (
          <label key={opt} className="flex items-center gap-1.5 text-sm cursor-pointer select-none">
            <Checkbox checked={selected.includes(opt)} onCheckedChange={() => toggle(opt)} />
            {opt}
          </label>
        ))}
      </div>
      {customValues.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {customValues.map((v) => (
            <span key={v} className="inline-flex items-center gap-1 bg-mist text-foreground rounded-pill px-2.5 py-0.5 text-xs">
              {v}
              <button type="button" className="rounded-pill text-ink-muted hover:text-foreground" onClick={() => onChange(selected.filter((x) => x !== v))}>
                <X className="w-3 h-3" />
              </button>
            </span>
          ))}
        </div>
      )}
      {allowCustom && (
        <div className="flex gap-2">
          <Input
            value={custom}
            onChange={(e) => setCustom(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addCustom(); } }}
            placeholder="Add custom…"
            className="h-8 text-sm max-w-[220px]"
          />
          <Button type="button" variant="outline" size="sm" onClick={addCustom}>Add</Button>
        </div>
      )}
    </div>
  );
}
